import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=1da7a1be&"
import script from "./step5.vue?vue&type=script&lang=js&"
export * from "./step5.vue?vue&type=script&lang=js&"
import style0 from "./step5.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports